export interface DriverRow {
  id: number;
  driver: string;
  identifier: string;
  phone: string;
}

export const NEW_ROW_ID = -1;

export type DriverDraft = Omit<DriverRow, 'id'>;
